// extracted by mini-css-extract-plugin
module.exports = {"bold":"styles_bold__19pOs","listItemSmall":"styles_listItemSmall__MMQrJ","listItemLabel":"styles_listItemLabel__1PZvx","mobileRight":"styles_mobileRight__FJsZP"};